import Api from '../Api';

class PhoneApi extends Api {
  constructor() {
    super('phones', 'phones');
  }
}
const phoneApi = new PhoneApi();
export default phoneApi;
